import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const QuizPage = lazy(() => import('@/features/quiz/pages/QuizPage'));
const ResultsPage = lazy(() => import('@/features/quiz/pages/ResultsPage'));

export const quizRoutes = (
  <>
    <Route path="/quiz/:id" element={<LazyRoute><QuizPage /></LazyRoute>} />
    <Route path="/results/:id" element={<LazyRoute><ResultsPage /></LazyRoute>} />
  </>
);
